import { render, staticRenderFns } from "./input-section.vue?vue&type=template&id=5a9c3bef&scoped=true"
import script from "./input-section.vue?vue&type=script&lang=js"
export * from "./input-section.vue?vue&type=script&lang=js"
import style0 from "./input-section.vue?vue&type=style&index=0&id=5a9c3bef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9c3bef",
  null
  
)

export default component.exports